import { render, staticRenderFns } from "./CadastrarClientes.vue?vue&type=template&id=2cbf9c9d&scoped=true&"
import script from "./CadastrarClientes.vue?vue&type=script&lang=js&"
export * from "./CadastrarClientes.vue?vue&type=script&lang=js&"
import style0 from "./CadastrarClientes.vue?vue&type=style&index=0&id=2cbf9c9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbf9c9d",
  null
  
)

export default component.exports